import { getDedicatedReportGroupBy, isDedicatedReportRoute } from '@/views/reports/report-route-behavior';
import type { DedicatedMetricsBundles } from '@/views/reports/report-metrics-runtime';
import { getStaticMetricsBundles } from '@/views/reports/report-metrics-bundles-static';

export const resolveRouteMetricsBundle = (
  routeName: string | symbol | null | undefined,
  dynamicBundles: DedicatedMetricsBundles,
) => {
  if (!isDedicatedReportRoute(routeName)) {
    return dynamicBundles.base;
  }

  const groupBy = getDedicatedReportGroupBy(routeName as string);
  const staticBundles = getStaticMetricsBundles();

  switch (groupBy) {
    case 'conversions':
      return {
        ...staticBundles.conversions,
        ...dynamicBundles.conversions,
        avaliable_metrics: dynamicBundles.conversions.avaliable_metrics.length
          ? dynamicBundles.conversions.avaliable_metrics
          : staticBundles.conversions.avaliable_metrics,
      };
    case 'postbacks':
      return {
        ...staticBundles.postbacks,
        ...dynamicBundles.postbacks,
        avaliable_metrics: dynamicBundles.postbacks.avaliable_metrics.length
          ? dynamicBundles.postbacks.avaliable_metrics
          : staticBundles.postbacks.avaliable_metrics,
      };
    case 'errors':
      return {
        ...staticBundles.errors,
        ...dynamicBundles.errors,
        avaliable_metrics: dynamicBundles.errors.avaliable_metrics.length
          ? dynamicBundles.errors.avaliable_metrics
          : staticBundles.errors.avaliable_metrics,
      };
    case 'live-clicks':
      return {
        ...staticBundles['live-clicks'],
        ...dynamicBundles['live-clicks'],
        avaliable_metrics: dynamicBundles['live-clicks'].avaliable_metrics.length
          ? dynamicBundles['live-clicks'].avaliable_metrics
          : staticBundles['live-clicks'].avaliable_metrics,
      };
    case 'live-visits':
      return {
        ...staticBundles['live-visits'],
        ...dynamicBundles['live-visits'],
        avaliable_metrics: dynamicBundles['live-visits'].avaliable_metrics.length
          ? dynamicBundles['live-visits'].avaliable_metrics
          : staticBundles['live-visits'].avaliable_metrics,
      };
    default:
      return {
        ...staticBundles.base,
        ...dynamicBundles.base,
      };
  }
};
